App.prototype.buildVariationTree = function (variationsContainer, variation_tree, main_product) {
    variation_tree.forEach(function (item) {

        var el_variation = document.createElement('div');
        el_variation.classList.add('variation');

        var el_variation_name = document.createElement('span');
        el_variation_name.textContent = item.variation.name;

        el_variation.appendChild(el_variation_name);
        // create variation option.
        item.variation_options.forEach((variaton_option) => {

            var el_variation_option = document.createElement('label');

            var el_variation_option_name = document.createElement('span');
            el_variation_option_name.classList.add('variation-option-standard');
            el_variation_option_name.textContent = variaton_option.name;

            switch (item.variation.type){
                case 'standard':
                    el_variation_option.appendChild(el_variation_option_name);
                    break;

                case 'color':
                    var el_variation_option_color = document.createElement('span');
                    el_variation_option_color.classList.add('variation-option-color');
                    el_variation_option_color.style.backgroundColor = variaton_option.primary_color;
                    el_variation_option.appendChild(el_variation_option_color);
                    break;

                case 'product_photo':
                    if (variaton_option.product_photo_url){
                        var el_variation_option_product_photo = document.createElement('img');
                        el_variation_option_product_photo.classList.add('variation-option-image');
                        el_variation_option_product_photo.src = variaton_option.product_photo_url;
                        el_variation_option.appendChild(el_variation_option_product_photo);
                    }else{
                        el_variation_option.appendChild(el_variation_option_name);
                    }
                    break;

                case 'image':
                    if (variaton_option.image){
                        var el_variation_option_image = document.createElement('img');
                        el_variation_option_image.classList.add('variation-option-image');
                        el_variation_option_image.src = variaton_option.image.url;
                        el_variation_option.appendChild(el_variation_option_image);
                    }else{
                        el_variation_option.appendChild(el_variation_option_name);
                    }
                    break;
            }

            var el_variation_option_radio = document.createElement('input');
            el_variation_option_radio.type = 'radio';
            el_variation_option_radio.dataset.variationId = item.variation.id;
            el_variation_option_radio.name = 'variation['+item.variation.id+']';
            el_variation_option_radio.value = variaton_option.id;
            el_variation_option_radio.checked = variaton_option.is_checked;

            el_variation_option_radio.addEventListener('change', function () {

                App.prototype.handleVariationChanges($(this), JSON.parse(main_product.product_variation_data_as_json), 0, main_product);

            });

            el_variation_option.appendChild(el_variation_option_radio);

            el_variation.appendChild(el_variation_option);

        });

        variationsContainer.append(el_variation);
    });

    const variations = JSON.parse(main_product.product_variation_data_as_json);
    App.prototype.checkSingleLevelVariationStatus(variations);
};
